import React from "react";
import { Button, Menu } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { supportedLanguages } from "../../i18n";
import { setCurrentLanguage } from "../../store/actions/language.action";
import type { RootState } from "../../store/store";

export function LanguageSwitcher() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const currentCode = useSelector(
    (state: RootState) => state.application.currentLanguage,
  );
  const current =
    supportedLanguages.find(({ code }) => code === currentCode) || supportedLanguages[0];

  return (
    <Menu
      position="bottom"
      shadow="md"
      size={160}
      menuButtonLabel={t("language.change")}
      control={
        <Button
          variant="subtle"
          compact
          className="language-switcher"
          aria-label={t("language.change")}
        >
          <span aria-hidden="true">{current.flag}</span>
          <span>{current.label}</span>
        </Button>
      }
    >
      <Menu.Label>{t("language.label")}</Menu.Label>
      {supportedLanguages.map((language) => (
        <Menu.Item
          key={language.code}
          onClick={() => dispatch(setCurrentLanguage(language.code))}
          aria-current={language.code === current.code ? "true" : undefined}
        >
          <span className="language-switcher__option">
            <span aria-hidden="true">{language.flag}</span>
            <span>{language.label}</span>
          </span>
        </Menu.Item>
      ))}
    </Menu>
  );
}
